import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M2.5 13q-.563 0-1.031-.458Q.999 12.083 1 11.5v-1.187a1.35 1.35 0 0 1 .125-.584l2.48-5.812q.165-.417.54-.667Q4.522 3 5 3h8q.624 0 1.063.427.437.427.437 1.073v7.875q0 .312-.125.594a1.6 1.6 0 0 1-.333.49l-4.188 4.187q-.375.375-.916.479-.542.105-.917-.125a1.24 1.24 0 0 1-.615-.792q-.135-.52-.031-1.02L8 13zm15-10q.604 0 1.052.448Q19 3.897 19 4.5v7q0 .605-.448 1.052A1.44 1.44 0 0 1 17.5 13a1.44 1.44 0 0 1-1.052-.448A1.44 1.44 0 0 1 16 11.5v-7q0-.604.448-1.052A1.44 1.44 0 0 1 17.5 3" }, null, -1)
  ]))]))
}
export default { render: render }